
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "aria-hidden": "true",
    "viewBox": "0 0 1024 1024"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M513.28 586.624c0 48.853333 50.986667 71.36 87.125333 38.656l263.104-237.973333a60.096 60.096 0 0 0-2.88-92.650667L599.210667 86.570667c-37.077333-29.504-85.930667-6.058667-85.930667 41.493333v91.626667C172.906667 259.413333 162.56 545.642667 170.666667 565.333333c9.322667 22.741333 38.613333 42.794667 87.189333 13.248 53.290667-32.426667 131.114667-61.312 255.424-65.834666v73.877333z m85.333333-391.466667l186.24 148.266667-186.24 168.426667V426.666667h-42.666666c-135.850667 0-236.565333 27.178667-307.306667 64 4.842667-9.194667 10.133333-24.832 16.106667-33.728C319.36 375.466667 384 311.978667 561.792 298.24l36.821333-2.688V195.157333z",
        "fill": "#333333"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M341.333333 704h554.666667v85.333333H341.333333zM128 874.666667h768v85.333333H128z",
        "fill": "#333333"
      }
    }
  ]
})
    }
  